<template>
  <div>
    <router-view />
  </div>
</template>

<script>
// import { constants } from "@/utils";
// import NavLink from "@/classes/NavLink";
// import store from "@/store";

export default {
  name: "ProfilePage",
  setup() {
    // onMounted(() => {
    // store.dispatch("nav/setMenu", { type: "MAIN_LINKS" });
    // store.dispatch("nav/setBreadcrumbs", [
    //   new NavLink(context.root.$t("global.home"), null, constants.HOME_ROUTE),
    //   new NavLink(context.root.$t("global.my-profile")),
    // ]);
    // });

    return {};
  },
};
</script>
